<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative"
                                                type="button">
                                                <span>{{ $t('settings.New_mail_template') }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="bg-white">
                                        <div class="row mt-4">                                            
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Name') }} *</label>
                                                    <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('settings.Name')">
                                                    <span v-if="v$.name.$error" class="text-sm text-danger">
                                                        {{ v$.name.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Subject') }} *</label>
                                                    <input v-model="state.subject" type="text" class="form-control form-control-default" :placeholder="$t('settings.Subject')">
                                                    <span v-if="v$.subject.$error" class="text-sm text-danger">
                                                        {{ v$.subject.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Body') }} *</label>
                                                    <textarea class="form-control form-control-default" :rows="10"
                                                        v-model="state.body"
                                                        :placeholder="$t('settings.Body')"></textarea>
                                                    <span v-if="v$.body.$error" class="text-sm text-danger">
                                                        {{ v$.body.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 mt-4">
                                        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                                        <button v-on:click="saveForm" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Save') }}</button> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';

export default {
    name: 'MailTemplate_create_page',

    setup() {
        const { t } = useI18n()

        const state = reactive({
            name: '',
            subject: '',
            body: ''
        })

        const rules = computed(() => {
            return {
                name: { required: helpers.withMessage(t('common.Required'), required) },
                subject: { required: helpers.withMessage(t('common.Required'), required) },
                body: { required: helpers.withMessage(t('common.Required'), required) },
            }
        })

        const v$ = useValidate(rules, state)

        return {
            state,
            v$
        }
    },
    components: {
    },
    async mounted() {        
    },
    methods: {
        async saveForm() {
            this.submitForm();
        },
        async submitForm() {
            // Put create logic
            try {
                // Trigger form validation
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    //console.log('Validation failed');
                    return;
                }

                
                this.$store.commit('setShowLoading', true);

                const response = await axios.post('mailtemplate/save', {
                    "name": this.state.name,
                    "subject": this.state.subject,
                    "body": this.state.body
                });
                this.gets = response.data;

                if (this.gets.success) {
                    this.$showSuccess('errors.Success_mail_template_created_successfully');                    
                    this.$router.push('/settings');
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            }
            catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
            
            this.$store.commit('setShowLoading', false);
        }
    }
}
</script>
<style scoped>
.multisteps-form__progress-btn.js-active span {
    color: #fff !important;
}
</style>